// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ChangeEventRposTabQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ChangeEventRposTabQuery = { __typename?: 'Query', changeEvent: { __typename?: 'ChangeEvent', id: string, status: Types.ChangeEventStatus, proposedOrientation?: { __typename?: 'ProjectReadyPlanConfigOrientationDetail', code: Types.ProjectReadyPlanConfigOrientation, name: string } | null | undefined, addedReadyPlanOptions: Array<{ __typename?: 'ChangeEventProposedOption', id: string, priceInCents: number, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, code: string, name: string, location?: { __typename?: 'Location', id: string, name: string } | null | undefined } }>, removedReadyPlanOptions: Array<{ __typename?: 'ChangeEventOriginalOption', id: string, priceInCents: number, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, code: string, name: string, location?: { __typename?: 'Location', id: string, name: string } | null | undefined } }>, canEditLineItems: { __typename?: 'PotentialOperation2', allowed: boolean } } };

export type ChangeEventRposTab_AddedReadyPlanOptionFragment = { __typename?: 'ChangeEventProposedOption', id: string, priceInCents: number, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, code: string, name: string, location?: { __typename?: 'Location', id: string, name: string } | null | undefined } };

export type ChangeEventRposTab_RemovedReadyPlanOptionFragment = { __typename?: 'ChangeEventOriginalOption', id: string, priceInCents: number, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, code: string, name: string, location?: { __typename?: 'Location', id: string, name: string } | null | undefined } };

export type ChangeEventRposTab_ReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', id: string, code: string, name: string, location?: { __typename?: 'Location', id: string, name: string } | null | undefined };

export type SaveChangeEventRposMutationVariables = Types.Exact<{
  input: Types.SaveChangeEventInput;
}>;


export type SaveChangeEventRposMutation = { __typename?: 'Mutation', saveChangeEvent: { __typename?: 'SaveChangeEventResult', changeEvent: { __typename?: 'ChangeEvent', id: string, proposedOrientation?: { __typename?: 'ProjectReadyPlanConfigOrientationDetail', code: Types.ProjectReadyPlanConfigOrientation, name: string } | null | undefined, addedReadyPlanOptions: Array<{ __typename?: 'ChangeEventProposedOption', id: string, priceInCents: number }>, removedReadyPlanOptions: Array<{ __typename?: 'ChangeEventOriginalOption', id: string, priceInCents: number }> } } };

export const ChangeEventRposTab_ReadyPlanOptionFragmentDoc = gql`
    fragment ChangeEventRposTab_ReadyPlanOption on ReadyPlanOption {
  id
  code
  name
  location {
    id
    name
  }
}
    `;
export const ChangeEventRposTab_AddedReadyPlanOptionFragmentDoc = gql`
    fragment ChangeEventRposTab_AddedReadyPlanOption on ChangeEventProposedOption {
  id
  priceInCents
  readyPlanOption {
    ...ChangeEventRposTab_ReadyPlanOption
  }
}
    ${ChangeEventRposTab_ReadyPlanOptionFragmentDoc}`;
export const ChangeEventRposTab_RemovedReadyPlanOptionFragmentDoc = gql`
    fragment ChangeEventRposTab_RemovedReadyPlanOption on ChangeEventOriginalOption {
  id
  priceInCents
  readyPlanOption {
    ...ChangeEventRposTab_ReadyPlanOption
  }
}
    ${ChangeEventRposTab_ReadyPlanOptionFragmentDoc}`;
export const ChangeEventRposTabDocument = gql`
    query ChangeEventRposTab($id: ID!) {
  changeEvent(id: $id) {
    id
    status
    proposedOrientation {
      code
      name
    }
    addedReadyPlanOptions {
      ...ChangeEventRposTab_AddedReadyPlanOption
    }
    removedReadyPlanOptions {
      ...ChangeEventRposTab_RemovedReadyPlanOption
    }
    canEditLineItems {
      allowed
    }
  }
}
    ${ChangeEventRposTab_AddedReadyPlanOptionFragmentDoc}
${ChangeEventRposTab_RemovedReadyPlanOptionFragmentDoc}`;

/**
 * __useChangeEventRposTabQuery__
 *
 * To run a query within a React component, call `useChangeEventRposTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeEventRposTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeEventRposTabQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChangeEventRposTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChangeEventRposTabQuery, ChangeEventRposTabQueryVariables> & ({ variables: ChangeEventRposTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChangeEventRposTabQuery, ChangeEventRposTabQueryVariables>(ChangeEventRposTabDocument, options);
      }
export function useChangeEventRposTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChangeEventRposTabQuery, ChangeEventRposTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChangeEventRposTabQuery, ChangeEventRposTabQueryVariables>(ChangeEventRposTabDocument, options);
        }
export function useChangeEventRposTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeEventRposTabQuery, ChangeEventRposTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChangeEventRposTabQuery, ChangeEventRposTabQueryVariables>(ChangeEventRposTabDocument, options);
        }
export type ChangeEventRposTabQueryHookResult = ReturnType<typeof useChangeEventRposTabQuery>;
export type ChangeEventRposTabLazyQueryHookResult = ReturnType<typeof useChangeEventRposTabLazyQuery>;
export type ChangeEventRposTabSuspenseQueryHookResult = ReturnType<typeof useChangeEventRposTabSuspenseQuery>;
export type ChangeEventRposTabQueryResult = Apollo.QueryResult<ChangeEventRposTabQuery, ChangeEventRposTabQueryVariables>;
export const SaveChangeEventRposDocument = gql`
    mutation SaveChangeEventRpos($input: SaveChangeEventInput!) {
  saveChangeEvent(input: $input) {
    changeEvent {
      id
      proposedOrientation {
        code
        name
      }
      addedReadyPlanOptions {
        id
        priceInCents
      }
      removedReadyPlanOptions {
        id
        priceInCents
      }
    }
  }
}
    `;
export type SaveChangeEventRposMutationFn = Apollo.MutationFunction<SaveChangeEventRposMutation, SaveChangeEventRposMutationVariables>;

/**
 * __useSaveChangeEventRposMutation__
 *
 * To run a mutation, you first call `useSaveChangeEventRposMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveChangeEventRposMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveChangeEventRposMutation, { data, loading, error }] = useSaveChangeEventRposMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveChangeEventRposMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveChangeEventRposMutation, SaveChangeEventRposMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveChangeEventRposMutation, SaveChangeEventRposMutationVariables>(SaveChangeEventRposDocument, options);
      }
export type SaveChangeEventRposMutationHookResult = ReturnType<typeof useSaveChangeEventRposMutation>;
export type SaveChangeEventRposMutationResult = Apollo.MutationResult<SaveChangeEventRposMutation>;
export type SaveChangeEventRposMutationOptions = Apollo.BaseMutationOptions<SaveChangeEventRposMutation, SaveChangeEventRposMutationVariables>;